// Content & data for the Xortec landing page (German)

export const IMG = {
  hero: "/images/hero-perimeter.jpg",
  mastDetail: "/images/mast-product.jpg",
  mastSection: "/images/mast-section.jpg",
  aluMaterial: "/images/alu-material.jpg",
  junctionBox: "/images/box-product.jpg",
  boxInside2: "/images/box-product.jpg",
  boxOutside: "/images/install-worker.jpg",
  mountedGroup: "/images/mounted-group.jpg",
  installWorker: "/images/install-worker.jpg",
  installHands: "/images/install-hands.jpg",
  network:
    "https://static.prod-images.emergentagent.com/jobs/54cbb079-8c89-486a-ba9f-31d1f51c93c1/images/a29927b9aa07ab722aeb2c9d06cf062a9c206c1648e0488041b8c2273846d6c2.png",
  industry:
    "https://static.prod-images.emergentagent.com/jobs/54cbb079-8c89-486a-ba9f-31d1f51c93c1/images/e8f6278551279501b3ec5cf458a6131ffbfac4a569098160d6c1b7cbafdef83a.png",
  traffic:
    "https://static.prod-images.emergentagent.com/jobs/54cbb079-8c89-486a-ba9f-31d1f51c93c1/images/5f3b905345beb3fb87af96dcc4b129a51bdc924618e499803ce231c503190466.png",
  logistics:
    "https://static.prod-images.emergentagent.com/jobs/54cbb079-8c89-486a-ba9f-31d1f51c93c1/images/c5d958b8032752d30a5270a854819274be2bc7a55134ae4761ef7546d8c50dc8.png",
};

export const CHALLENGES = [
  {
    title: "Einzelkomponenten unterschiedlicher Hersteller",
    text: "Inkompatible Schnittstellen, getrennte Garantien und ein hoher Abstimmungsaufwand verzögern Projekte.",
  },
  {
    title: "Aufwendige Montage vor Ort",
    text: "Jeder Mast, jeder Switch, jeder Anschluss wird separat geplant – das kostet Zeit, Geld und Nerven.",
  },
  {
    title: "Fehlende Systemintegration",
    text: "Kamera, PoE, Glasfaser und Überspannungsschutz werden selten als Gesamtsystem betrachtet.",
  },
  {
    title: "Witterung & Umwelt",
    text: "Außenanlagen müssen Wind, Salz, Hitze und UV-Strahlung über Jahrzehnte trotzen.",
  },
  {
    title: "Unsichere Strom- und Netzwerkversorgung",
    text: "Spannungsspitzen und unstabile Verbindungen gefährden die Betriebssicherheit kritischer Anlagen.",
  },
  {
    title: "Hoher Aufwand bei Service und Erweiterung",
    text: "Spätere Erweiterungen scheitern oft an unklarer Dokumentation und proprietären Lösungen.",
  },
];

export const SOLUTION_NODES = [
  { key: "video", label: "Videoüberwachung", desc: "IP-Kameras, NVR, Analytics" },
  { key: "alarm", label: "Einbruchmeldetechnik", desc: "Detektion & Meldewege" },
  { key: "network", label: "Aktive Netzwerktechnik", desc: "Switching, PoE, Glasfaser" },
  { key: "mast", label: "Kameramast", desc: "Aluminium, kippbar oder starr" },
  { key: "box", label: "Anschlusskasten", desc: "Edelstahl, IP-geschützt" },
];

export const MAST_FEATURES = [
  "Hochwertige Aluminiumkonstruktion",
  "Korrosionsbeständig & langlebig",
  "Starre und kippbare Mastvarianten",
  "Einfache Wartung durch durchdachte Zugänge",
  "Sichere, integrierte Kabelführung",
  "Integration aktiver Netzwerk- & Sicherheitstechnik",
  "Verschiedene Durchmesser & Höhen",
  "Modular erweiterbar – auch nachträglich",
];

export const MAST_USE_CASES = [
  "Videoüberwachung",
  "Perimeterschutz",
  "Verkehrstechnik",
  "Industrie",
  "KRITIS",
  "Energieversorgung",
  "Kommunen",
];

export const BOX_FEATURES = [
  "Robuste Edelstahlkonstruktion (IP-geschützt)",
  "Aufnahme aktiver Netzwerkkomponenten",
  "Optional mit barox LT-LPITE-402GBTME",
  "Zentral verwaltbare Netzwerkversorgung",
  "Integration von Glasfaseranschlüssen (LWL)",
  "Aktive Wärmeentlüftung",
  "Professionelle Kabeleinführung",
  "Überspannungsschutz optional",
  "Bis zu 4 IP-Kameras anschließbar",
  "Passend für alle Xortec Kameramasten",
];

export const ADVANTAGES = [
  { icon: "Layers", title: "Alles aus einer Hand", text: "Mast, Anschlusskasten und aktive Netzwerktechnik – ein Ansprechpartner, ein System." },
  { icon: "Wrench", title: "Weniger Installationsaufwand", text: "Vormontiert geliefert, schneller einsatzbereit." },
  { icon: "Zap", title: "Schnellere Inbetriebnahme", text: "Geprüfte Komponenten reduzieren Fehlerquellen auf der Baustelle." },
  { icon: "Settings2", title: "Wartungsfreundlich", text: "Durchdachte Zugänge, klare Beschriftung, standardisierte Schnittstellen." },
  { icon: "ShieldCheck", title: "Zukunftssicher", text: "Skalierbare Architektur – heute installieren, morgen erweitern." },
  { icon: "Network", title: "Netzwerkready", text: "PoE, Glasfaser, Management – vollständig integrierbar." },
  { icon: "Scaling", title: "Skalierbar", text: "Von der einzelnen Kamera bis zur flächendeckenden Infrastruktur." },
  { icon: "Lock", title: "KRITIS- & NIS2-orientiert", text: "Architektur, die regulatorischen Anforderungen gerecht wird." },
  { icon: "Activity", title: "Hohe Betriebssicherheit", text: "Überspannungsschutz, redundante Konzepte, robuste Hardware." },
];

export const APPLICATIONS = [
  { title: "Industrie & Logistik", image: "logistics", icon: "Factory" },
  { title: "KRITIS-Infrastruktur", image: "kritis", icon: "ShieldAlert" },
  { title: "Verkehr & Bahn", image: "traffic", icon: "TrainTrack" },
  { title: "Energieversorgung", image: "energy", icon: "Bolt" },
  { title: "Städte & Kommunen", image: "cities", icon: "Building2" },
  { title: "Perimeterschutz", image: "perimeter", icon: "Fence" },
  { title: "Rechenzentren", image: "industry", icon: "Server" },
  { title: "Sicherheits- & Überwachungsanlagen", image: "security", icon: "Cctv" },
];

export const TECH_TABS = [
  {
    value: "mast",
    label: "Mastvarianten",
    rows: [
      ["Material", "Aluminium, pulverbeschichtet"],
      ["Höhen", "4 m – 12 m (auf Anfrage höher)"],
      ["Bauart", "Starr oder kippbar"],
      ["Durchmesser", "Standardisiert, projektabhängig"],
      ["Lieferumfang", "Mast, Anker, Zubehör"],
    ],
  },
  {
    value: "tilt",
    label: "Kipplösungen",
    rows: [
      ["Bedienung", "Manuell über Mast­fuß­mechanik"],
      ["Sicherheit", "Verriegelbar"],
      ["Vorteil", "Wartung ohne Hubbühne möglich"],
      ["Optional", "Gasdruckfeder-Unterstützung"],
    ],
  },
  {
    value: "connect",
    label: "Anschlussmöglichkeiten",
    rows: [
      ["IP-Kameras", "Bis zu 4 pro Anschlusskasten"],
      ["Schnittstellen", "RJ45, LWL (LC/SC)"],
      ["PoE-Standards", "IEEE 802.3af/at/bt"],
      ["Stromversorgung", "230 V AC / 48 V DC"],
    ],
  },
  {
    value: "network",
    label: "Netzwerk & Glasfaser",
    rows: [
      ["Switch (optional)", "barox LT-LPITE-402GBTME Switch"],
      ["Management", "Web, SNMP, zentrale Verwaltung"],
      ["Redundanz", "Ring-/Sterntopologie möglich"],
      ["VLAN/QoS", "Vollumfänglich unterstützt"],
      ["Glasfaser", "Singlemode & Multimode (LC/SC)"],
      ["LWL vorkonfektioniert", "Optional ab Werk"],
      ["Spleißbox", "Im Anschlusskasten integrierbar"],
      ["Reichweite Glasfaser", "Projektabhängig bis km-Bereich"],
    ],
  },
  {
    value: "accessories",
    label: "Zubehör & Schutz",
    rows: [
      ["Überspannungsschutz", "Optional, modular"],
      ["Pulverbeschichtung", "RAL-Farben auf Anfrage"],
      ["Fundament", "Schraubfundament oder Beton"],
      ["Belüftung", "Aktive Wärmeentlüftung im Kasten"],
    ],
  },
];

export const TRUST_BADGES = [
  "Für KRITIS & NIS2 geeignet",
  "Made for Professional Security",
  "Netzwerkfähig & skalierbar",
];
